import { defineStyleConfig } from '@chakra-ui/system';

export const Container = defineStyleConfig({
    baseStyle: {
        maxWidth: 'container.xxl',
    },
    variants: {
        form: {
            maxWidth: '522px',
            px: 0,
        },
    },
});
